import { DSCBColoredTiles, DSResource } from 'shared-definitions/types'
import { ApiComponent, ApiContentBlockColoredTiles } from 'data-source/types.wp'
import { coloredBoxMapper } from 'data-source/mappers/coloredBoxMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

interface CBColoredTilesMapperOpts<T extends DSResource, A extends ApiComponent>
  extends PLinkMapperOpts {
  componentItemMapper: (input: A) => T | T[]
}

export function cbColoredTiles<T extends DSResource, A extends ApiComponent>(
  input: ApiContentBlockColoredTiles<A>,
  opts: CBColoredTilesMapperOpts<T, A>
): DSCBColoredTiles<T> {
  return {
    title: input.title,
    pLink: input.slug ? pLinkMapper(input.slug, opts) : null,
    resource: 'cb-colored-tiles',
    tiles: input.items.map(i => coloredBoxMapper(i, opts)),
    blocks: input.content.flatMap(opts.componentItemMapper),
  }
}
